import React from 'react';

const Logo = props => {
  return (
    <img
      width="42px"
      height="42px"
      alt="Logo"
      src="/static/tp_logo.png"
      {...props}
    />
  );
};

export default Logo;
